<app-whatsapp-button></app-whatsapp-button>
<!-- LOGIN -->
<div class="container">
    <div class="row justify-content-center">
        <div class="col-11 col-lg-5">
            <div class="justify-content-center">
                <h1 [innerHTML]="pageTitle">Atendimento - Pagmob</h1>
            </div>
            <p>Bem-vindo!</p>
            <p i18n="@@login-text">A Pagmob facilita ainda mais o seu atendimento de forma simples, rápida e 100% online.</p>

            <p i18n="@@login-obs"><strong>Aviso importante</strong>: O LOGIN É PESSOAL E INTRANSFERÍVEL. Evite sair de casa e cuide de sua saúde.<br/></p>
        </div> <!-- /col -->
    </div> <!-- /row -->

    <div class="row justify-content-center">
        <div class="col-12 col-lg-6">

            <div class="form-panel form-panel-lg" [ng2-loading]="showSpinner">
                <h2>Entrar</h2>
                <form name="form" (ngSubmit)="f.form.valid && efetuarLogin()" #f="ngForm">
                    <div class="form-group" [ngClass]="{ 'invalid': verificarCNPJ() && (cpf.invalid && cpf.touched) || (verificarCNPJ() && cpf.invalid && f.submitted)  }">
                        <label for="cnpj">CNPJ</label>
                        <input [textMask]="{mask: cnpjmask}" placeholder="__.___.___/____-__" type="text" class="form-control" id="cnpj" name="cnpj" [(ngModel)]="model.cpf" #cpf="ngModel" [required]="verificarCNPJ()">
                    </div>

                    <p class="text-center">ou</p>

                    <div class="form-group" *ngIf="features.login.includes( 'email' )" [ngClass]="{ 'invalid': verificarEmail() && (email.invalid && email.touched) || (verificarEmail() && email.invalid && f.submitted)  }">
                        <label for="email">E-mail</label>
                        <input type="text" class="form-control" id="email" name="email" placeholder="" [(ngModel)]="model.email" #email="ngModel" [required]="verificarEmail()">
                    </div>

                    <div class="form-group" [ngClass]="{ 'invalid': (senha.invalid && senha.touched) || (senha.invalid && f.submitted) }">
                        <label>Senha</label>
                        <input type="password" name="senha" class="form-control" [(ngModel)]="model.senha" #senha="ngModel" [ngClass]="{ 'is-invalid': senha.touched && senha.invalid }" required>
                    </div>

                    <div class="form-group center">
                        <re-captcha #rc (resolved)="resolved($event)" [siteKey]="reCaptchaKey" required></re-captcha>
                    </div>

                    <p class="caption" style="margin-top: 10px;"><a routerLink="/esqueci">Esqueci minha senha</a></p>
                    <button type="submit" class="btn btn-primary btn-block mb-3">Entrar</button>
                    <hr *ngIf="features.signUp"><p *ngIf="features.signUp" class="text-center"><a class="login-link" routerLink="/cadastro/empresa">Ainda não tem uma conta? <span>Cadastre-se</span>.</a></p>
                </form>
            </div> <!-- /form-panel -->
        </div> <!-- /form -->
    </div> <!-- /row -->
</div> <!-- /container -->
<!-- LOGIN -->
